import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import './OnboardingFAB.scss';
import { openModal, setModalData } from '~/Redux/Modules/Modal';
import { ONBOARDING_PROGRESS_MODAL } from '~/Config/Modals';
import { updateOnboardingComplete } from '~/Redux/Modules/UserOptions/actions';

export class OnboardingFAB extends Component {
  handleOpenModal = () => {
    const { dispatch, remainingTasks, userOptions } = this.props;

    if (remainingTasks === 0 && userOptions) {
      dispatch(updateOnboardingComplete(userOptions.id, true))
        .then(() => {
          dispatch(setModalData({}));
          dispatch(openModal(ONBOARDING_PROGRESS_MODAL));
        })
        .catch(error => {
          console.error('Error updating onboarding complete', error);
        });
    } else {
      dispatch(setModalData({}));
      dispatch(openModal(ONBOARDING_PROGRESS_MODAL));
    }
  };

  render() {
    const { remainingTasks } = this.props;
    const onClick = this.handleOpenModal;
    return (
      <div className="onboarding-fab" onClick={onClick}>
        {remainingTasks > 0 ? (
          <div className="fab-content">
            <div className="fab-text">
              <div className="fab-count">{remainingTasks}</div>
              <div className="fab-label">Unlock Bonus</div>
            </div>
          </div>
        ) : (
          <div className="fab-content" onClick={onClick}>
            <div className="fab-text">
              <div className="fab-label">Bonus Unlocked</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

OnboardingFAB.propTypes = {
  dispatch: propTypes.func,
  remainingTasks: propTypes.number.isRequired,
  userOptions: propTypes.object,
};

const mapStateToProps = ({ Onboarding, UserOptions }) => {
  const onboardingTasks = Onboarding.onboarding.onboardingTasks;
  const remainingTasks = onboardingTasks.filter(task => !task.isCompleted).length;
  return {
    remainingTasks,
    userOptions: UserOptions.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingFAB);
